import Box from '@mui/material/Box';
import { TextField } from '@/atoms/TextField';
import { Select, MenuItem } from '@/atoms/Select';
import { FormField } from '@/molecules/FormField';
import { Button } from '@/atoms/Button';
import { FormPageLayout } from '@/templates/FormPageLayout';

/**
 * FormExample
 * Example create-entity form built on FormPageLayout + FormField.
 */
export function FormExample() {
  return (
    <Box sx={{ p: 3 }}>
      <FormPageLayout
        title="Connect cloud account"
        description="Provide read-only credentials so AiStrike can begin scanning."
        actions={
          <>
            <Button variant="ghost">Cancel</Button>
            <Button variant="primary">Connect</Button>
          </>
        }
      >
        <FormField label="Provider" htmlFor="provider">
          <Select id="provider" defaultValue="aws" fullWidth size="small">
            <MenuItem value="aws">AWS</MenuItem>
            <MenuItem value="gcp">Google Cloud</MenuItem>
            <MenuItem value="azure">Azure</MenuItem>
          </Select>
        </FormField>
        <FormField label="Account ID" htmlFor="acct" helperText="12-digit AWS account ID.">
          <TextField id="acct" placeholder="123456789012" />
        </FormField>
        <FormField label="Role ARN" htmlFor="arn">
          <TextField id="arn" placeholder="arn:aws:iam::123456789012:role/AiStrike" />
        </FormField>
      </FormPageLayout>
    </Box>
  );
}
